export default {
  showFooter: true,
  isSidebarCompact: false,
  showBreadcrumb: false,
  menuAutoCollapsed: false,
  mode: 'light',
  layout: 'side',
  splitMenu: false,
  sideMode: 'light',
  isFooterAside: false,
  isSidebarFixed: true,
  isHeaderFixed: true,
  isUseTabsRouter: false,
  showHeader: true,
  brandTheme: '#E34D59',
};
